import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Content = styled.div`
    margin-top: 2rem;
`;


export const DateSelectContainer = styled.div<{ span?: boolean }>`
    width:100%;
    display:grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap:10px;
    margin-bottom: 20px;
    position: relative;
    >div:nth-of-type(2),>div:nth-of-type(1){
    grid-column: ${props => props.span ? "2 / span 2" : "unset"};
    width: ${props => props.span ? "50%" : "unset"};
    }

    ${mq(Devices.mobile)}{
        
    }
`;

export const DateSelectRow = styled.div`
    display:flex;
    align-items:center;
`;

export const DateSelector = styled.div`
    height:28px;
    border:1px solid #2A848E;
    border-radius: 5px;
    display:flex;
    align-items:center;
    gap:8px;
    padding:0 12px;

    span{
        color:#2A848E;
        font-size: 14px;
        font-weight: 600;
    }

    svg{
        margin-left: auto;
        height:80%;
    }
`;


export const SubTitle = styled.span<{ marginRight?: boolean }>`
    font-size: 16px;
    font-weight: 500;
    margin-right: ${props => props.marginRight ? "auto" : "0"};
`;

export const TimeDDL = styled.select<{ disable?: boolean }>`
    
    height:28px;
    border:1px solid #2A848E;
    border-radius: 5px;
    display:flex;
    align-items:center;
    padding:0 14px;
    cursor: pointer;
    color:#2A848E;
    font-size: 14px;
    font-weight: 600;
    outline: none;
    opacity: ${props => props.disable ? "0.5" : "1"};
    pointer-events: ${props => props.disable ? "none" : "unset"};

    option{
        max-height: 300px;
    }
`;